import thunkMiddleware from 'redux-thunk';
import { ApolloClient } from '@apollo/client';
import { FeatureFlagKeys } from '@communication-center/data-objects';

export const thunkMiddlewareExtraArgument: { apolloClient: ApolloClient<$TSFixMe>; featureFlags: { [key in FeatureFlagKeys]: boolean } } = {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'ApolloClien... Remove this comment to see the full error message
    apolloClient: null,
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type '{ audiences... Remove this comment to see the full error message
    featureFlags: null
};

export default thunkMiddleware.withExtraArgument(thunkMiddlewareExtraArgument);
